module.exports = __webpack_public_path__ + "img/pshkykqm8fn8lvbl04i13861wegjqsovbm2d77b3f3-3f83-49ca-8687-35c08962ef3f.ef8d20bb.png";